class BESSAppProjectCredit extends BESSAppBase {

    constructor(node) {
        super();
        this.node = node;
        this.code = node.data('credit-code');
        this.title = node.find('.title-content').text().trim();
        this.questionDependencies = nullIfUndefined(node.data('credit-question-dependencies'));
        this.codeSelector = this.code.replaceAll('.', '_')
        this.creditScore = new BESSAppProjectCreditScore(this);
        this.scopeOut = new BESSAppProjectCreditScopeOut(this);
        this.annotate = new BESSAppProjectCreditNotes(this);
        this.summaryNode = $('.app-credit-summary[data-credit="'+this.code+'"]');
    }

    start() {
        //this.log('Start', this);
        this.api = BESSApp.instance.services.api.project.credit(this.code);

        this.#updateProfilerHeaders();
        this.subscribeToEvents(BESSAppViewUpdatedEvent.name, this.#onViewUpdated);
        if (this.questionDependencies != null) {
            _.forEach(this.questionDependencies.split(','), function (questionDependency) {

                if (questionDependency.length > 0) {
                    this.subscribeToEvents(BESSAppQuestionAnswerDependencyEvent.eventFor(questionDependency),
                        this.#creditDependencyChanged);
                }

            }.bind(this));
        }
        this.fireEvent(new BESSAppCreditDependencyEvent(this.code, this.isCreditEnabled()), true);
    }

    #onViewUpdated() {
        this.#updateProfilerHeaders();
    }

    #creditDependencyChanged(event) {
        if (event.changing) {
            this.doDelayed(this.#checkDependency, 1200);
        }
    }

    #checkDependency() {
        this.log("#creditDependencyChanged");
        this.api.apiCheckDependencies(this.#updateDependency.bind(this));
    }

    #updateDependency(result) {

        let enabled = result.enabled;
        let scopedOut = result.scoped_out;
        let scopedOutLocked = result.scoped_out_locked;
        let wasEnabled = this.isCreditEnabled();

        if (scopedOut) {
            this.node.addClass('app-credit-scoped-out');
            this.node.addClassIf('app-credit-scoped-out-locked', scopedOutLocked);
            this.node.find('.app-credit-scope-out-reason').text(result.reason);
        } else if (!enabled) {
            this.node.addClass('app-credit-disabled');
            this.node.find('.app-credit-disabled-reason').text(result.reason);
        } else {
            this.node.removeClass('app-credit-disabled');
            this.node.removeClass('app-credit-scoped-out');
            this.node.removeClass('app-credit-scoped-out-locked');

        }

        this.node.addClassIf('app-credit-scoped-out', scopedOut);


        if (enabled !== wasEnabled) {
            this.fireEvent(new BESSAppCreditDependencyEvent(this.code, enabled, true));
        }
    }

    update(score,
           passed,
           mandatoryWarn,
           scopedOut,
           scopedOutLocked,
           scoreRating,
           profilersHTML,
           contribution,
           dependency,
           supportingEvidenceRequired,
           supportingEvidenceComplete) {
        this.#updateProfilers(profilersHTML);
        this.node.addClassIf('app-project-mandatory-warn', mandatoryWarn);
        this.node.addClassIf('app-credit-scoped-out-locked', scopedOutLocked);
        this.node.find('.weighting-value').text('' + contribution);
        this.node.find('.app-credit-supporting-evidence')
            .addClassIf('complete', supportingEvidenceComplete)
            .addClassIf('incomplete', !supportingEvidenceComplete)
            .showIf(supportingEvidenceRequired);
        this.creditScore.update(score, scopedOut, scoreRating);

        let scorePercent = '' + score + '%';
        this.summaryNode.find('.app-credit-summary-score').animate({'width': scorePercent});
        this.summaryNode.find('.score').text(scorePercent);
        this.summaryNode.find('.app-credit-pass-fail-indicator')
            .addClassIf('app-credit-has-passed', passed)
            .addClassIf('app-credit-has-failed', !passed);
        this.#updateDependency(dependency);
    }

    #updateProfilers(profilersHTML) {
        let existingProfilers = this.node.find('.app-credit-profilers');
        let newProfilers = $(profilersHTML);
        existingProfilers.replaceWith(newProfilers);
        this.forEach(newProfilers.find('.app-profiler'), this.#updateProfilerNode);
    }

    #updateProfilerNode(profilerNode) {
        let profilerId = $(profilerNode).data('profiler-id');
        let profilerData = document.getElementById(profilerId).textContent;
        let thisProfilerData = JSON.parse(profilerData);
        BESSApp.instance.managers.profilers.replaceProfiler(thisProfilerData);
    }

    #updateProfilerHeaders() {
        this.lastHeader = null;
        this.forEach(this.node.find('.app-profiler-item-title'), this.#updateProfilerHeader);
    }

    #updateProfilerHeader(node) {
        let header = $(node);
        let parent = header.parents('.app-profiler-item');
        if (parent.is(':visible')) {
            if (this.lastHeader != null) {
                let currentHeader = header.text();
                let lastHeader = this.lastHeader.text();

                let currentTitleBlock = header.parents('thead');
                currentTitleBlock.showIf(currentHeader !== lastHeader);
            }
            this.lastHeader = header;
        }
    }

    isCreditEnabled() {
        return !this.node.hasClass('app-credit-disabled')
    }
}